<template>
    <!-- <Breadcrumbs main="Setting" mains="Customer Management" title="Customer Management" /> -->
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Customer List</h5>
                    <button class="btn btn-primary" @click="openModal()">
                        <i class="fa fa-plus"></i> Add Customer
                    </button>
                </div>
            </div>
            <div class="card-body">
                <DataTable
                    :headers="headers"
                    :items="customers"
                    :loading="loading"
                    :total="total"
                    :params="params"
                    @update:params="updateParams"
                >
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-warning me-2" @click="editCustomer(item as Customer)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deleteCustomer(item as Customer)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="modal fade bd-example-modal-lg" id="customerModal" tabindex="-1" ref="modalRef" aria-labelledby="customerModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <h3 class="modal-header justify-content-center border-0">{{ modalTitle }}</h3>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Divisi</label>
                                <select v-if="form.code == ''" v-model="form.divisi" class="form-select">
                                    <option :value="null" disabled>Select Divisi</option>
                                    <option v-for="option in divisiOptions" :key="option.ID" :value="option">
                                        {{ option.name }}
                                    </option>
                                </select>
                                <input v-else v-model="form.divisi.name" :disabled="true" type="text" class="form-control" required>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">DivisiTeam</label>
                                <select v-if="form.code == ''" v-model="form.divisi_team" class="form-select">
                                    <option :value="null" disabled>Select DivisiTeam</option>
                                    <option v-for="option in divisiTeamOptions" :key="option.ID" :value="option">
                                        {{ option.name }}
                                    </option>
                                </select>
                                <input v-else v-model="form.divisi_team.name" :disabled="true" type="text" class="form-control" required>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Code</label>
                                <input v-model="form.code" :disabled="true" type="text" class="form-control" required>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Name</label>
                                <input v-model="form.name" type="text" class="form-control" required>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">No Telp</label>
                                <input v-model="form.no_telp" type="text" class="form-control">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Keluhan</label>
                                <input v-model="form.keluhan" type="text" class="form-control">
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Street Name</label>
                                <input v-model="form.street_name" type="text" class="form-control">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Desa</label>
                                <input v-model="form.desa" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label class="form-label">RT</label>
                                <input v-model="form.rt" type="text" class="form-control">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">RW</label>
                                <input v-model="form.rw" type="text" class="form-control">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Kelurahan</label>
                                <input v-model="form.kelurahan" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Patokan</label>
                            <input v-model="form.patokan" type="text" class="form-control">
                        </div>
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Province</label>
                                <select v-model="form.province" class="form-select">
                                    <option :value="null" disabled>Select Province</option>
                                    <option v-for="option in provinceOptions" :key="option.province" :value="option.province">
                                        {{ option.province }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">City</label>
                                <select v-model="form.city" class="form-select">
                                    <option :value="null" disabled>Select City</option>
                                    <option v-for="option in cityOptions" :key="option.city" :value="option.city">
                                        {{ option.city }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Area</label>
                                <select v-model="form.area" class="form-select">
                                    <option :value="null" disabled>Select Area</option>
                                    <option v-for="option in areaOptions" :key="option.area" :value="option.area">
                                        {{ option.area }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Postal Code</label>
                            <input v-model="form.postal_code" type="text" class="form-control">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Address</label>
                            <textarea :value="customerAddress" type="text" class="form-control" disabled />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" type="button" @click="closeModal">Cancel</button>
                        <button class="btn btn-primary" type="submit" @click="saveCustomer">Save</button>
                    </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, computed, nextTick, watch } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/Datatable.vue'
import { Modal } from 'bootstrap'

// {{ Define Customer interface }}
interface Customer {
    ID: any; // Allow null for new customers
    code: string;
    name: string;
}

// {{ Define Params interface }}
interface DataTableParams {
    page: number;
    size: number;
    search: string;
}

const headers = [
    { text: 'Actions', value: 'actions' },
    { text: 'Code', value: 'code' },
    { text: 'Name', value: 'name' },
    { text: 'Telp', value: 'no_telp' },
    { text: 'Sales', value: 'user_email' },
    { text: 'Address', value: 'address' }
]

// {{ Apply types to refs and reactive objects }}
const customers = ref<Customer[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})

const modalTitle = ref('')
const divisiOptions = ref<{ ID: any, name: string }[]>([])
const divisiTeamOptions = ref<{ ID: any, name: string }[]>([])
const provinceOptions = ref<{ province: string, city:string, area: string }[]>([])
const cityOptions = ref<{ province: string, city:string, area: string }[]>([])
const areaOptions = ref<{ province: string, city:string, area: string }[]>([])

const form = reactive<any>({
    ID: null,
    code: '',
    name: '',
    divisi: null,
    divisi_team: null,
    no_telp: '',
    keluhan: '',
    street_name: '',
    desa: '',
    rt: '',
    rw: '',
    kelurahan: '',
    patokan: '',
    province: null,
    city: null,
    area: null,
    postal_code: '',
    address: ''
})

// Add this data data array
import * as master from "@/api/services/MasterRequest";

const fetchDivisi = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/divisi/list", {page:1, size:10000,search:''});
        divisiOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch customers')
    }
    loading.value = false
}

const fetchProvince = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/destination/province", {page:1, size:10000,search:''});
        provinceOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch customers')
    }
    loading.value = false
}

const fetchCity = async (province: string) => {
    loading.value = true
    try {
        const resp = await master.postRequest("/destination/city", {
            page: 1,
            size: 10000,
            search: province
        });
        cityOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch cities')
    }
    loading.value = false
}

const fetchArea = async (city: string) => {
    loading.value = true
    try {
        const resp = await master.postRequest("/destination/area", {
            page: 1,
            size: 10000,
            search: city
        });
        areaOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch cities')
    }
    loading.value = false
}

import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const fetchCustomers = async () => {
    loading.value = true
    try {
        if(session.getUser().role == 'SALES'){
            params.user_email = session.getUser().email
        }
        // Simulate API delay
        const resp = await master.postRequest("/customer/list", {...params});
        customers.value = resp.data
        total.value = resp.total

    } catch (error) {
        toast.error('Failed to fetch customers')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchCustomers()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

// View modal state
const viewModalRef = ref<HTMLElement | null>(null)
let bsViewModal: any | null = null


const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}

const saveCustomer = async () => {
    form.address = customerAddress.value; // <-- Use .value to get the string result
    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        if (form.ID) {
            // Update existing customer in data data
            await master.postRequest("/customer/update", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('Customer updated successfully');
                    closeModal();
                    fetchCustomers(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to update customer');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to update customer');
            })
        } else {
            // Add new customer to data data
            await master.postRequest("/customer/create", form).then((resp) => {
                if (resp.status === 200) {
                    toast.success('Customer created successfully');
                    closeModal();
                    fetchCustomers(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to create customer');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to create customer');
            })
        }
    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to save customer');
    } finally {
        loading.value = false; // End loading state
    }
}

// {{ Define editCustomer function }}
const editCustomer =  async (customer: Customer) => {
    loading.value = true; // Indicate loading state
    try {
        // Fetch customer data
        const resp = await master.postRequest("/customer/data", {ID: customer.ID});
        if (resp.status === 200) {
            openModal(resp.data); // Call openModal with the customer data
        } else {
            toast.error('Not found customer');
        }
    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to data customer');
    } finally {
        loading.value = false; // End loading state
    }
}


// {{ Add type annotation for customer parameter }}
const deleteCustomer = async (customer: Customer) => {
    if (!confirm('Are you sure you want to delete this customer?')) return

    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        await master.postRequest("/customer/delete", {ID: customer.ID}).then((resp) => {
            if (resp.status === 200) {
                toast.success('Customer deleted successfully');
                closeModal();
                fetchCustomers(); // Re-fetch to update the table view
            } else {
                toast.error('Failed to delete customer');
            }
        })

    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to delete customer');
    } finally {
        loading.value = false; // End loading state
    }
}

// Update openModal to ensure accounts array exists
const openModal = (customer: any | null = null) => {
    if (customer) {
        modalTitle.value = 'Edit Customer'
        isEditing.value = true; // Stop watchers

        Object.assign(form, customer);
        nextTick(() => {
            // Set Divisi (object reference)
            if (customer.divisi && divisiOptions.value.length > 0) {
                form.divisi = divisiOptions.value.find((option) => option.ID === (customer.divisi.ID || customer.divisi)) || null;
                divisiTeamOptions.value = form.divisi.divisiTeams;
            } else {
                form.divisi = null;
                divisiTeamOptions.value = [];
            }

            // Set DivisiTeam (object reference)
            if (customer.divisi_team && divisiTeamOptions.value.length > 0) {
                form.divisi_team = divisiTeamOptions.value.find(opt => opt.ID === (customer.divisi_team.ID || customer.divisi_team)) || null;
            } else {
                form.divisi_team = null;
            }

            // Set Province (string value)
            if (customer.province && provinceOptions.value.length > 0) {
                form.province = provinceOptions.value.find(opt => opt.province === customer.province)?.province || null;
                // Fetch cities for this province
                if (form.province) {
                    fetchCity(form.province);
                }
            } else {
                form.province = null;
            }

            // Set City (string value) - after cities are fetched
            setTimeout(() => {
                if (customer.city && cityOptions.value.length > 0) {
                    form.city = cityOptions.value.find(opt => opt.city === customer.city)?.city || null;
                    // Fetch areas for this city
                    if (form.city) {
                        fetchArea(form.city);
                    }
                } else {
                    form.city = null;
                }

                // Set Area (string value) - after areas are fetched
                setTimeout(() => {
                    if (customer.area && areaOptions.value.length > 0) {
                        form.area = areaOptions.value.find(opt => opt.area === customer.area)?.area || null;
                    } else {
                        form.area = null;
                    }
                    isEditing.value = false; // Re-enable watchers after all assignments
                }, 500);
            }, 500);
        })
    } else {
        modalTitle.value = 'Create Customer'
        Object.keys(form).forEach(key => form[key] = (Array.isArray(form[key]) ? [] : null));
        form.divisi = null;
        form.divisi_team = null;
        form.code = '';
        form.name = '';
        form.no_telp = '';
        form.keluhan = '';
        form.street_name = '';
        form.desa = '';
        form.rt = '';
        form.rw = '';
        form.kelurahan = '';
        form.patokan = '';
        form.province = null;
        form.city = null;
        form.area = null;
        form.postal_code = '';
        form.address = '';
    }
    if (bsModal) {
        bsModal.show()
    }
}

const isEditing = ref(false) // Flag to control watcher execution

onMounted(() => {
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
    if (viewModalRef.value) {
        bsViewModal = new Modal(viewModalRef.value)
    }
    fetchDivisi()
    fetchProvince()
})

// Watch for divisi changes to update divisiTeamOptions
watch(() => form.divisi, (newDivisi) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newDivisi && newDivisi.divisiTeams) {
        divisiTeamOptions.value = newDivisi.divisiTeams
        form.divisi_team = null // reset selection
    } else {
        divisiTeamOptions.value = []
        form.divisi_team = null
    }
})

// Watch for province changes to fetch cities
watch(() => form.province, (newProvince) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newProvince && newProvince) {
        fetchCity(newProvince)
        form.city = null // reset city selection
        areaOptions.value = []
        form.area = null
    } else {
        cityOptions.value = []
        form.city = null
        areaOptions.value = []
        form.area = null
    }
})

// Watch for city changes to fetch areas
watch(() => form.city, (newCity) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newCity && newCity) {
        fetchArea(newCity)
        form.area = null // reset area selection
    } else {
        areaOptions.value = []
        form.area = null
    }
})

const customerAddress = computed(() => {
    const parts = [
        form.street_name ? form.street_name : '',
        form.desa ? 'Desa ' + form.desa : '',
        form.rt ? `Rt ${form.rt}` : '',
        form.rw ? `Rw ${form.rw}` : '',
        form.kelurahan ? `Kel ${form.kelurahan}` : '',
        form.patokan ? form.patokan : '',
        form.province ? form.province : '',
        form.city ? form.city : '',
        form.area ? form.area : '',
        form.postal_code ? form.postal_code : ''
    ]
    return parts.filter(Boolean).join(', ')
})
</script>